import React from 'react'
import DoctorTreatmentService from '../Service/doctorTreatmentService'
// import DoctorTreatmentService from '../Service/doctorTreatmentService'
// import DetailDoctorService from '../Service/DetailDoctorService'
import './doctortreatment.css'
import { config } from '../Config/config'
import DetailDoctorService from '../Service/DetailDoctorService'
import FormInput from './formInput'
import ModalHapus from './modalHapus'
import ModalHapusBerhasil from './modalHapusBerhasil'
import ModalBerhasilSimpan from './modalBerhasilSimpan'
import Index from './index'
import doctorTreatmentService from '../Service/doctorTreatmentService'
// import ModalHapus from './modalHapus'
// import { WithContext as ReactTags } from 'react-tag-input';


export default class tambahTindakan extends React.Component {

    DoctorTreatmentModel = {
        // id:"",
        doctor_id: "",
        name: "",
        is_delete: false,

    }

    constructor() {
        super()
        this.state = {
            List: [],
            treatList: [],
            treatList2: [],
            Model: this.DoctorTreatmentModel,
            Mode: "",
            errors: {},
        }
    }

    loadList = async () => {
        const responID = await DetailDoctorService.getID(localStorage.getItem(config.biodata_id))
        if (responID.success) {
            this.setState({
                dokter_id: responID.result
            })
            {
                this.state.dokter_id.map(data => {
                    this.setState({
                        data : {
                            ...this.state.data,
                            id_doctor : data._id
                        }
                    })
                })
            }
        }
        const responSP = await DetailDoctorService.getSP()
        if (responSP.success) {
            this.setState({
                listSP : responSP.result
            })
        }

        const responBio = await DetailDoctorService.getProfile(this.state.data)
        if (responBio.success) {
            this.setState({
                bioList: responBio.result,
            })
            {
                this.state.bioList.map(data => {
                    this.setState({
                        image : data.image,
                        data : {
                            ...this.state.data,
                            spesialis : data.sp
                        }
                    })
                })
            }
        }

        const responTreat = await DetailDoctorService.getTreatment(this.state.data)
        if (responTreat.success) {
            this.setState({
                treatList: responTreat.result,
            })
        }

        const responEdu = await DetailDoctorService.getEducation(this.state.data)
        if (responEdu.success) {
            this.setState({
                eduList: responEdu.result,
            })
        }

        const responHist = await DetailDoctorService.getHistory(this.state.data)
        if (responHist.success) {
            this.setState({
                histList: responHist.result
            })
        }

        const responLoc = await DetailDoctorService.getLokasi(this.state.data)
        if (responHist.success) {
            this.setState({
                locList: responLoc.result
            })
        }
    }


    componentDidMount() {
        this.loadList()
    }

    changeHandler = name => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [name]: value
            }
        })
    }

    //button submit
    saveHandler = async () => {
        // const respons = await DoctorTreatmentService.cekTindakanByDoctorIdByName(this.state.Model.name)
        // var name = {}
        // console.log(respons.result)
        // if (respons.success) {
        //     name = respons.result
        // }
        // console.log(name)

        // var name = {}


        // if (this.handleValidation(name)) {
        if (this.state.Mode == "Hapus Tindakan") {
            // alert("test delete")
            this.state.Model.is_delete = true

            const respond = await DoctorTreatmentService.editDataDelete(this.state.Model)
            if (respond.success) {
                // alert("Succes Delete Data")
                this.loadList()
                this.setState({
                    Model: this.DoctorTreatmentModel,
                    ShowModalDel: false,
                    ShowModalDelBerhasil: true
                })
                // window.location.reload()
                
            }
        } 
        
        const respons = await DoctorTreatmentService.cekTindakanByName(this.state.Model)
        var name = {}
        console.log(respons.result)
        if (respons.success) {
            name = respons.result
        }


        if (this.state.Mode == "Tambah Tindakan") {
            // alert('TESTTTT')
            if (this.handleValidation(name)) {
                const respond = await DoctorTreatmentService.addData(this.state.Model)
                // alert("test savehandler")

                if (respond.success) {
                    // alert("Succes Save Data")
                    this.loadList()
                    
                    this.setState({
                        Model: this.DoctorTreatmentModel,
                        ShowModal: false,
                        ShowModalBerhasilSimpan: true
                    })
                    // window.location.reload()
                }
            }
        }
    }

    handleValidation(name) {
        let fields = this.state.Model;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "* Nama tindakan harus diisi";
        }

        //Isinyya spasi
        else if (!fields["name"] || fields["name"].trim() == "") {
            formIsValid = false
            errors["nameEmpty"] = "* Nama tidak boleh kosong"
        }

        //Cek nama tindakan bila sudah ada
        else if (name != undefined) {
            formIsValid = false;
            errors["name_existed"] = "* Nama sudah ada untuk tindakan tersebut";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    //button DELETE
    // deleteHandler = async (_id) => {
    //     const respond = await DoctorTreatmentService.deleteData(_id)
    //     this.setState({
    //     })
    //     if (respond.success) {
    //         alert("Success Delete Data")
    //         this.loadlist()
    //     }
    // }

    createHandler = async (_id) => {
        this.setState({
            Model: {
                ...this.state.Model,
                doctor_id: this.props.idDoctor
            },
            Mode: "Tambah Tindakan",
            ShowModal: true,
            // ShowModalBerhasilSimpan: true
            // ShowModalSimpan: true,
            // Model: this.DoctorTreatmentModel
        })

    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModal: false,
            ShowModalDel: false,
            ShowModalDelBerhasil: false,
            ShowModalBerhasilSimpan: false,
            errors: {},
            Model: {
                ...this.state.Model,
                name: "",
            },
            
        })
        // window.location.reload()
        this.loadList()
    }



    hapusHandler = async (_id) => {
        const respond = await DoctorTreatmentService.getById(_id)

        // console.log(respond)

        this.setState({
            Model: {
                ...this.state.Model,
                id: this.props.idTindakan
            },
            Mode: "Hapus Tindakan",
            ShowModalDel: true,
            ShowModalDelErr: true
        })

        if (respond.success) {
            this.setState({
                Model: respond.result
            })
        }
    }


    render() {
        const { List, Model, errors, Mode, ShowModal, id_doctor, treatList } = this.state
        const { idDoctor, idTindakan } = this.props
        return (
            <div>
                {/* {JSON.stringify(Model)} */}
                {/* {JSON.stringify(this.state.DoctorTreatmentModel)} */}
                {/* {JSON.stringify(id_doctor)} */}


                {/* <div class="container"> */}
                <div class="text-center">
                    <br />
                    <h4>Tindakan</h4>
                </div>

                <div class="tab-content" style={{ height: 500 }}>
                    <div class="tab-pane show active" id="tindakan">
                        <div class="btn-toolbar pull-left mrTindakan">
                            {/* <button type="button" class="btn btn-primary"> <i class="fa fa-plus plus-circle" ></i> */}
                            {/* <div class="button"> */}

                            {
                                // this.state.treatList2.map(data => {
                                treatList.map(data => {
                                    return (
                                        <button type="button" class="btn btn-primary buttonx mr-3 "><i class="fa fa-close float-right"
                                            onClick={() => this.hapusHandler(data._id)}> </i>
                                            <tr class="text-center tindakan" >
                                                <td>{data.name}</td>
                                            </tr>
                                        </button>


                                    )
                                })
                            }
                        </div>
                        <button type="button" class="btn btn-circle btn-primary mb-3 float-right bawah tambah" onClick={this.createHandler}><i class="fa fa-plus plus-circle" ></i>
                            <i> </i></button>
                    </div>
                </div>


                {/* <FormInput /> */}
                <FormInput
                    changeHandler={this.changeHandler}
                    // checkedHandler={this.checkedHandler}
                    saveHandler={this.saveHandler}
                    Model={Model}
                    ShowModal={ShowModal}
                    List={this.state.List}
                    createHandler={this.createHandler}
                    cancelHandler={this.cancelHandler}
                    handleValidation={this.handleValidation}
                    errors={errors}
                    Mode={Mode}
                />

                <ModalHapus
                    changeHandler={this.changeHandler}
                    createHandler={this.createHandler}
                    ShowModalDel={this.state.ShowModalDel}
                    cancelHandler={this.cancelHandler}
                    saveHandler={this.saveHandler}
                    List={List}
                    Model={this.state.Model}
                    errors={errors}
                />

                <ModalHapusBerhasil
                    changeHandler={this.changeHandler}
                    createHandler={this.createHandler}
                    ShowModalDel={this.state.ShowModalDel}
                    ShowModalDelBerhasil={this.state.ShowModalDelBerhasil}
                    cancelHandler={this.cancelHandler}
                    saveHandler={this.saveHandler}
                    List={List}
                    Model={this.state.Model}
                    errors={errors}
                />

                <ModalBerhasilSimpan
                    changeHandler={this.changeHandler}
                    createHandler={this.createHandler}
                    ShowModalDel={this.state.ShowModalDel}
                    ShowModalBerhasilSimpan={this.state.ShowModalBerhasilSimpan}
                    cancelHandler={this.cancelHandler}
                    saveHandler={this.saveHandler}
                    List={List}
                    Model={this.state.Model}
                    errors={errors}
                />

                {/* </div> */}

            </div >
        )
    }
}


